import { createRouter, createWebHistory } from "vue-router";

import DashboardLayout from "@/layout/DashboardLayout";

import Locations from "../views/Locations.vue";
import Location from "../views/Location.vue";
import TipSplits from "../views/TipSplits.vue";
import TipSplitDetail from "../views/TipSplitDetail.vue";

const routes = [
  {
    path: "/",
    redirect: "/locations",
    component: DashboardLayout,
    children: [
      {
        path: "/locations",
        name: "locations",
        components: { default: Locations },
      },
      {
        path: "/locations/:locationId",
        name: "location",
        components: { default: Location },
      },
      {
        path: "/tip-splits",
        name: "tip splits",
        components: { default: TipSplits },
      },
      {
        path: "/tip-splits/:reportId",
        name: "tip split detail",
        components: { default: TipSplitDetail },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes,
});

export default router;
